import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// kendo
import { Loader } from "@progress/kendo-react-indicators";
// components
import DepotTable from "../../../../components/table/depotTable";
// routes
import { TELEPHONE_DIRECTORY_DEPOT_DETAILS } from "../../../../routes";
import { Confirmation } from "../../../../components/dialog/confirmation";


const DepotListBody = ({ 
  loading, 
  data, 
  onSortAction,
  handleDeleteAction,
  onToggleDialog,
  incidentStatuses,
  currentIncidentStatus,
  onChangeIncidentStatus,
  onSaveIncidentStatus,
  showChangeStatusDialog, 
  hideDeleteButton}) => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedID,setSelectedID] = useState(null);
  const handleActionDropdownClicked = (event, val) => {
    console.log("handleActionDropdownClicked event:", event);
    console.log("handleActionDropdownClicked val:", val);
    console.log('val.dataItem---',val.dataItem);
    const { id } = val.dataItem;
    
    if (event.value == 'Delete'){
      console.log("Delete-",id);
      setSelectedID(id);      
      setShowConfirm(true);
    }
    else{
      console.log("View Detail: ",id);
      navigate(`${TELEPHONE_DIRECTORY_DEPOT_DETAILS}?id=${id}`);
      if ('parent_depot' in val.dataItem){ 
        console.log("Call Child Detail: ");
        const {parent_depot}= val.dataItem;
        navigate(`${TELEPHONE_DIRECTORY_DEPOT_DETAILS}?id=${id}&parent_depot=${parent_depot}`);}
      else{
        console.log("Call Parent Detail: ");
        navigate(`${TELEPHONE_DIRECTORY_DEPOT_DETAILS}?id=${id}`);}
      
    };    
  };
  const handleConfirmDelete = (()=>{
    setShowConfirm(false);
    console.log(selectedID);
    handleDeleteAction(selectedID);
  });
  return (
    <React.Fragment>
      {loading ? (
        <Loader className="dr-safe-list-loader" type="infinite-spinner" />
      ) : (
        <DepotTable
          data={data}
          actionDropdownClicked={handleActionDropdownClicked}
          hideDeleteOption={hideDeleteButton}
        //   onSortBy={onSortAction}
        />
      )}
      {showConfirm && (
        <Confirmation 
          onClickYes={handleConfirmDelete}
          onClickNo={()=>setShowConfirm(false)}        
        />
      )}
    </React.Fragment>
    
  );
};

export default DepotListBody;
